module.exports = __webpack_public_path__ + "static/media/KGantin-96-1.47d9e4c6.jpg";